import React from 'react';
import { connect } from 'react-redux';
import { Button, Icon, Input } from 'semantic-ui-react';
import { withCallcenterAPI } from '../callcenter-api';
import { mapDispatchToProps, mapStateToProps } from './dispatch';

class ButtonpanelBlacklist extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            phone: null,
            comment: 'Причина не указана',
        };
    }

    onChangePhone = event => {
        this.setState({
            phone: event.target.value,
        });
    };

    onChangeComment = event => {
        this.setState({
            comment: event.target.value,
        });
    };

    onClickSearch = () => {
        const { phone } = this.state;
        this.props.blacklistFetch(phone);
    };

    onClickAddToBlacklist = () => {
        const { phone, comment } = this.state;
        this.props.blacklistAdd(phone, comment);
    };

    render() {
        const { isLoading, phone } = this.state;
        const isBlacklistDisable = phone === '';

        return (
            <Button.Group>
                <Button color={'twitter'}>
                    <Input
                        placeholder="71321234567"
                        onChange={this.onChangePhone}
                    />
                </Button>
                <Button
                    icon
                    disabled={isBlacklistDisable}
                    loading={isLoading}
                    labelPosition="right"
                    color={'twitter'}
                    onClick={this.onClickSearch}
                >
                    <Icon name="search" />
                    Поиск
                </Button>
            </Button.Group>
        );
    }
}

export default withCallcenterAPI(
    connect(mapStateToProps, mapDispatchToProps)(ButtonpanelBlacklist),
);
